const Links = {
  home: "/home",
  square: "/home/#/square",
  tools: "home/#/aiTools",
  create: "/home/#/mx",
  api: "/home",
  vipList: "/home/#/member",
  document: "/home/#/member",
  help: "/home/#/course",
  mjdocument: "/tutorial/index.html",
  privacy: "https://doc.360qnw.com/web/#/79",
  agreement: "https://doc.360qnw.com/web/#/78",
};
export default Links;
